var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B8A12A96-E2A1-472F-B38D-39AE66A936A5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "URL-Expanded",
    transform: "translate(-693.000000, -340.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-2",
    transform: "translate(680.000000, 327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icons---Filled/Add",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05882353,0 C9.61110828,-1.01453063e-16 10.0588235,0.44771525 10.0588235,1 L10.058,7.941 L17,7.94117647 C17.5522847,7.94117647 18,8.38889172 18,8.94117647 L18,9.05882353 C18,9.61110828 17.5522847,10.0588235 17,10.0588235 L10.058,10.058 L10.0588235,17 C10.0588235,17.5522847 9.61110828,18 9.05882353,18 L8.94117647,18 C8.38889172,18 7.94117647,17.5522847 7.94117647,17 L7.941,10.058 L1,10.0588235 C0.44771525,10.0588235 0,9.61110828 0,9.05882353 L0,8.94117647 C0,8.38889172 0.44771525,7.94117647 1,7.94117647 L7.941,7.941 L7.94117647,1 C7.94117647,0.44771525 8.38889172,1.01453063e-16 8.94117647,0 L9.05882353,0 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add-white.4c3a5f1698495ebb2315835ac3195752.svg";
export { ForwardRef as ReactComponent };